import flags, {Flags} from '@fo/shared-types/flags';

const getFlags = (): Flags => flags;

export default getFlags;
